import { useContext, useEffect, useMemo, useState } from "react";
import _ from "underscore";
import { convertTo24HourFormat, dateConvert, generateTimeSlots, timeStringToDate } from "../../../utils/Helper";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { ToastContext } from "../../../context/ToastContext";
import { callautopopulate } from "../../../services/callautopop";
import { decryptData } from "../../../utils/encrypt";

export const useCabinBookingCalendar = ({ cabinList, callApi }) => {

    const { showInfo } = useContext(ToastContext);
    const [date, setDate] = useState(new Date());
    const [week, setWeek] = useState({ start: (new Date()), end: (new Date()).setDate((new Date()).getDate() + 6) });
    const [view, setView] = useState("day");
    const [coldef, setColDef] = useState([]);
    const [rowData, setRowData] = useState([]);
    const [weekColDef, setWeekColDef] = useState([]);
    const [weekRowData, setWeekRowData] = useState([]);
    const [showBooking, setShowBooking] = useState(false);
    const [today, setToday] = useState(dateConvert(date, "day-month-year") === dateConvert(new Date(), "day-month-year") ? true : false);
    const [shiftTime, setShiftTime] = useState({ from: "", to: "" })
    const [allShift, setAllShift] = useState(null)
    const [booking, setBooking] = useState({ columnData: {}, data: {} });
    const [cabinHistoryData, setCabinHistoryData] = useState([]);
    const [formSlot, setFormSlot] = useState({ time: {}, disable: [] });
    const [loader, setLoader] = useState(false);
    const [loggedInUser, setLoggedInUser] = useState(decryptData(sessionStorage.getItem("user_info"))?.[0] || {});
    const [editData, setEditData] = useState({});

    useEffect(() => {
        callautopopulate("user_info")?.then(res => {
            setLoggedInUser(res?.user_info?.[0]);
        })
    }, [])

    useEffect(() => {
        getCabinBookingDetails();
    }, [view, date, week, callApi])

    useEffect(() => {
        !_.isEmpty(allShift) && (view === "day" ? formatData() : formatWeekData());
    }, [view, date, week, allShift])

    useEffect(() => {
        setToday(dateConvert(date, "day-month-year") === dateConvert(new Date(), "day-month-year") ? true : false)
    }, [date])

    const getCabinBookingDetails = async () => {
        try {
            setLoader(true);
            setCabinHistoryData([]);
            const payload = {
                from_date: view === "week" ? dateConvert(week?.start, "iso-string")?.split("T")?.[0] : dateConvert(date, "iso-string")?.split("T")?.[0] || "",
                to_date: view === "week" ? dateConvert(week?.end, "iso-string")?.split("T")?.[0] : dateConvert(date, "iso-string")?.split("T")?.[0] || ""
            }
            const res = await services.getInvokeRemote("POST", Urls("GETCABINBOOKINGDETAILS"), payload);
            if (res) {
                const data = res?.body?.data?.cabin_booking_details_list;
                setCabinHistoryData(data);
                const shift = res?.body?.data?.shift_details_get;
                if (view === "day") {
                    setAllShift({ from: shift?.[0]?.shift_startdate ? shift?.[0]?.shift_startdate : "09:00:00", to: shift?.[0]?.shift_enddate ? shift?.[0]?.shift_enddate : "22:00:00" });
                } else {
                    if (!_.isEmpty(shift)) {
                        shift?.map((item) => {
                            if (!item?.shift_startdate) {
                                item["shift_startdate"] = "09:00:00";
                                item["shift_enddate"] = "22:00:00";
                            }
                        })
                        setAllShift(shift);
                    } else {
                        let shiftArr = [];
                        let fromDate = week?.start;
                        while (dateConvert(fromDate, "iso-string") <= dateConvert(week?.end, "iso-string")) {
                            const obj = {
                                shift_date: dateConvert(fromDate, "iso-string"),
                                shift_startdate: "09:00:00",
                                shift_enddate: "22:00:00"
                            }
                            shiftArr.push(obj);
                            fromDate = new Date((new Date(fromDate)).setDate((new Date(fromDate)).getDate() + 1));
                        }
                        setAllShift(shiftArr);
                    }
                }
                if (view === "day") {
                    if (!_.isEmpty(shift)) {
                        setShiftTime({ from: shift?.[0]?.shift_startdate ? shift?.[0]?.shift_startdate : "09:00:00", to: shift?.[0]?.shift_enddate ? shift?.[0]?.shift_enddate : "22:00:00" });
                    } else {
                        setShiftTime({ from: "09:00:00", to: "22:00:00" });
                    }
                }
                setLoader(false);
            }
        } catch (error) {
            console.error("Error: ", error);
            setLoader(false);
        }
    }

    const formatData = async () => {
        // set column defs
        let columndef = [{
            field: "time", headerName: "", width: 80, cellStyle: { textAlign: "center", fontWeight: "bold" },
        }];
        cabinList?.forEach((item) => {
            item?.cabins?.forEach((cabin) => {
                const obj = {
                    field: `cabin_${cabin?.cabin_id}`,
                    headerName: cabin?.name,
                    flex: 1,
                    cellRenderer: (params) => {
                        const data = params?.value
                        data?.map((item) => {
                            if (item?.minutes === 15 || item?.minutes === -15) {
                                item["width"] = 50
                                item["height"] = 50
                            } else if (item?.minutes === 30 || item?.minutes === -30 || item?.minutes === 45 || item?.minutes === -45) {
                                item["width"] = 100
                                item["height"] = 50
                            } else if (item?.minutes === 60 || item?.minutes === -60) {
                                item["width"] = 100
                                item["height"] = 100
                            } else {
                                item["width"] = 50
                                item["height"] = 50
                            }
                        })
                        const colorArr = ["#67a5ff", "#0d6efd", "#0656ceff", "#154997ff"]
                        return (
                            <div style={{ width: "100%", height: "100%", backgroundColor: params?.data?.bg_color || "transparent" }} className={`${!params?.data?.disabled ? "cabin-calendar-cell c-pointer" : ""} d-flex flex-wrap position-relative`}>
                                {data?.map((item, index) => (
                                    <div
                                        title={`${item?.time + " :- " + item?.user_display_name}${item?.booking_title ? `\nTitle: ` + item?.booking_title : "" || ""}${item?.participant_names ? `\nUsers: ` + item?.participant_names : "" || ""}`}
                                        key={index} style={{ width: `${item?.width}%`, height: `${item?.height}%`, fontSize: "0.7rem", backgroundColor: colorArr[index], top: `${item?.top}%`, left: `${item?.left}%` }} className="text-white d-flex align-items-center justify-content-center position-absolute" onClick={() => { if (item?.book_by === loggedInUser?.user_code) { setEditData(item); } else { setEditData({ show_error: true }) } }}>
                                        <div className="text-truncate p-1 d-flex align-items-center justify-content-center" style={{ height: "100%" }}>{(item?.user_display_name?.length > 12 && item?.width === 50) ? item?.user_display_name?.slice(0, 10) + "..." : item?.user_display_name}</div>
                                    </div>
                                ))}
                            </div>
                        )
                    }
                }
                columndef.push(obj);
            })
        })
        setColDef(columndef);

        // set row data
        const slots = generateTimeSlots(60, allShift?.from, allShift?.to)
        let row = [];

        slots?.forEach((item) => {
            let obj = {
                time: item?.label?.split("-")?.[0]?.trim(),
                cell_start: item?.value?.start,
                cell_end: item?.value?.end,
                shift_start: allShift?.from,
                shift_end: allShift?.to,
                date: timeStringToDate(item?.value?.end, date),
                disabled: timeStringToDate(item?.value?.end, date) < new Date() ? true : false,
                bg_color: timeStringToDate(item?.value?.end, date) < new Date() ? "#efefef" : today ? "#ecf4ff" : "transparent"
            };
            row.push(obj);
        })

        let timeWiseData = [];
        let formattedRowData = row?.map((item) => {
            _.pluck(columndef, "field")?.forEach((item2) => {
                if (item2 !== "time") {
                    const cabinWiseData = _.filter(cabinHistoryData, (item) => item?.cabin_id === parseInt(item2?.split("_")?.[1] || 0))?.sort((a, b) => a?.from_datetime?.localeCompare(a?.from_datetime));
                    let formattedArray = [];
                    if (!_.isEmpty(cabinWiseData)) {

                        cabinWiseData?.forEach((cabinData) => {
                            const fromDateTime = convertTo24HourFormat(dateConvert(cabinData?.from_datetime, "time"), true);
                            const toDateTime = convertTo24HourFormat(dateConvert(cabinData?.to_datetime, "time"), true)
                            if (fromDateTime >= item?.cell_start && toDateTime <= item?.cell_end) {
                                timeWiseData?.push(cabinData);
                            } else if (fromDateTime >= item?.cell_start && fromDateTime < item?.cell_end) {
                                formattedArray.push(cabinData);
                            }
                        })

                        const result = [];

                        formattedArray.forEach(booking => {
                            const from = new Date(booking.from_datetime);
                            const to = new Date(booking.to_datetime);

                            let currentStart = new Date(from);

                            while (currentStart < to) {
                                const intervalEndHour = currentStart.getHours() + 1;
                                const intervalEnd = new Date(currentStart);
                                intervalEnd.setHours(intervalEndHour, 0, 0, 0);
                                const currentEnd = new Date(Math.min(intervalEnd.getTime(), to.getTime()));

                                result.push({
                                    ...booking,
                                    from_datetime: currentStart,
                                    to_datetime: currentEnd
                                });
                                timeWiseData = [...timeWiseData, ...result];

                                currentStart = new Date(currentEnd);
                            }
                        });
                    }
                    item[item2] = []
                }
            })
            _.uniq(_.pluck(timeWiseData, "cabin_id"))?.forEach((id) => {
                const cabinsPluck = _.filter(timeWiseData, (data) => (data?.cabin_id === id && convertTo24HourFormat(dateConvert(data?.from_datetime, "time"), true) >= item?.cell_start && convertTo24HourFormat(dateConvert(data?.to_datetime, "time"), true) <= item?.cell_end));
                cabinsPluck?.map((data) => {
                    const fromDate = new Date(data?.from_datetime);
                    const toDate = new Date(data?.to_datetime);
                    let fromTime = fromDate?.getMinutes();
                    let toTime = toDate?.getMinutes();
                    if (fromDate?.getHours() === toDate?.getHours()) {
                        data["minutes"] = (parseInt(fromTime) - parseInt(toTime)) === 0 ? 60 : (parseInt(fromTime) - parseInt(toTime));
                    } else {
                        data["minutes"] = parseInt(fromTime) - (parseInt(toTime) + 60);
                    }
                    data["top"] = (fromTime >= 30 || (data?.minutes === -45 && toTime === 0)) ? 50 : 0
                    data["left"] = (Math.abs(data?.minutes) === 15 && (toTime === 30 || toTime === 0)) ? 50 : 0
                    data["time"] = `${dateConvert(data?.from_datetime, "time")} - ${dateConvert(data?.to_datetime, "time")}`
                    data["booking_time"] = { start: convertTo24HourFormat(dateConvert(data?.from_datetime, "time"), true), end: convertTo24HourFormat(dateConvert(data?.to_datetime, "time"), true) }
                })
                item[`cabin_${id}`] = _.uniq(cabinsPluck, "time")?.sort((a, b) => new Date(a?.from_datetime) - new Date(b?.from_datetime));
            })
            return item;
        })
        setRowData(formattedRowData);
    }

    const formatWeekData = async () => {
        // set column defs
        let columndef = [
            {
                field: "week_days", headerName: "Days", width: 100, spanRows: true, cellStyle: { textAlign: "center", fontWeight: "bold", display: "flex", alignItems: "center", fontSize: "1.2rem", whiteSpace: "pre-wrap" }
            },
            {
                field: "time", headerName: "Time", width: 80, cellStyle: { textAlign: "center", fontWeight: "bold" }
            }
        ];
        cabinList?.forEach((item) => {
            item?.cabins?.forEach((cabin) => {
                const obj = {
                    field: `cabin_${cabin?.cabin_id}`,
                    headerName: cabin?.name,
                    flex: 1,
                    cellRenderer: (params) => {
                        const data = params?.value
                        data?.map((item) => {
                            if (item?.minutes === 15 || item?.minutes === -15) {
                                item["width"] = 50
                                item["height"] = 50
                            } else if (item?.minutes === 30 || item?.minutes === -30 || item?.minutes === 45 || item?.minutes === -45) {
                                item["width"] = 100
                                item["height"] = 50
                            } else if (item?.minutes === 60 || item?.minutes === -60) {
                                item["width"] = 100
                                item["height"] = 100
                            } else {
                                item["width"] = 50
                                item["height"] = 50
                            }
                        })
                        const colorArr = ["#67a5ff", "#0d6efd", "#0656ceff", "#154997ff"]
                        return (
                            <div style={{ width: "100%", height: "100%", backgroundColor: params?.data?.bg_color || "transparent" }} className={`${!params?.data?.disabled ? "cabin-calendar-cell c-pointer" : ""} d-flex flex-wrap position-relative`}>
                                {data?.map((item, index) => (
                                    <div
                                        title={`${item?.time + " :- " + item?.user_display_name}${item?.booking_title ? `\nTitle: ` + item?.booking_title : ""}${item?.participant_names ? `\nUsers: ` + item?.participant_names : ""}`}
                                        key={index} style={{ width: `${item?.width}%`, height: `${item?.height}%`, fontSize: "0.7rem", backgroundColor: colorArr[index], top: `${item?.top}%`, left: `${item?.left}%` }} className="text-white d-flex align-items-center justify-content-center position-absolute" onClick={() => { if (item?.book_by === loggedInUser?.user_code) { setEditData(item); } else { setEditData({ show_error: true }) } }}>
                                        <div className="text-truncate p-1 d-flex align-items-center justify-content-center" style={{ height: "100%" }}>{(item?.user_display_name?.length > 12 && item?.width === 50) ? item?.user_display_name?.slice(0, 10) + "..." : item?.user_display_name}</div>
                                    </div>
                                ))}
                            </div>
                        )
                    }
                }
                columndef.push(obj);
            })
        })
        setWeekColDef(columndef);

        // set row data
        let daysArr = [];
        let fromDate = new Date(week?.start);
        const toDate = new Date(week?.end);
        while (dateConvert(fromDate, "iso-string") <= dateConvert(toDate, "iso-string")) {
            const shiftData = _.filter(allShift, (item) => item?.shift_date?.split("T")?.[0] === dateConvert(fromDate, "iso-string")?.split("T")?.[0])
            if (!_.isEmpty(shiftData)) {
                const obj = {
                    label: `${dateConvert(fromDate, "day-month-year")}\n${(new Date(fromDate)).toLocaleDateString('en-US', { weekday: 'long' })}`,
                    day: (new Date(fromDate)).toLocaleDateString('en-US', { weekday: 'long' }),
                    dayIndex: (new Date(fromDate))?.getDay(),
                    shift_start: shiftData?.[0]?.shift_startdate,
                    shift_end: shiftData?.[0]?.shift_enddate,
                    full_date: fromDate
                }
                if ((new Date(fromDate))?.getDay() !== 0) {
                    daysArr.push(obj);
                }
            }
            fromDate = new Date((new Date(fromDate)).setDate((new Date(fromDate)).getDate() + 1));
        }
        let row = [];
        daysArr?.forEach(day => {
            const slots = generateTimeSlots(60, day?.shift_start, day?.shift_end);
            slots?.forEach((item) => {
                let obj = {
                    week_days: day?.label,
                    time: item?.label?.split("-")?.[0]?.trim(),
                    day_index: day?.dayIndex,
                    shift_start: day?.shift_start,
                    shift_end: day?.shift_end,
                    cell_start: item?.value?.start,
                    cell_end: item?.value?.end,
                    date: timeStringToDate(item?.value?.end, day?.full_date),
                    full_date: day?.full_date,
                    disabled: timeStringToDate(item?.value?.end, day?.full_date) < new Date() ? true : false,
                    bg_color: timeStringToDate(item?.value?.end, day?.full_date) < new Date() ? "#efefef" : dateConvert(new Date(), "day-month-year") === dateConvert(timeStringToDate(item?.value?.end, day?.full_date), "day-month-year") ? "#ecf4ff" : "transparent"
                };
                row.push(obj);
            })
        })

        let timeWiseData = [];
        let formattedRowData = row?.map((item) => {
            _.pluck(columndef, "field")?.forEach((item2) => {
                if (item2 !== "time" && item2 !== "week_days") {
                    const cabinWiseData = _.filter(cabinHistoryData, (cabin) => (cabin?.cabin_id === parseInt(item2?.split("_")?.[1] || 0) && (dateConvert(item?.full_date, "iso-string")?.split("T")?.[0] === cabin?.from_datetime?.split("T")?.[0])));
                    let formattedArray = [];
                    if (!_.isEmpty(cabinWiseData)) {

                        cabinWiseData?.forEach((cabinData) => {
                            const fromDateTime = convertTo24HourFormat(dateConvert(cabinData?.from_datetime, "time"), true);
                            const toDateTime = convertTo24HourFormat(dateConvert(cabinData?.to_datetime, "time"), true)
                            if (fromDateTime >= item?.cell_start && toDateTime <= item?.cell_end) {
                                timeWiseData?.push(cabinData);
                            } else if (fromDateTime >= item?.cell_start && fromDateTime < item?.cell_end) {
                                formattedArray.push(cabinData);
                            }
                        })

                        const result = [];

                        formattedArray.forEach(booking => {
                            const from = new Date(booking.from_datetime);
                            const to = new Date(booking.to_datetime);

                            let currentStart = new Date(from);

                            while (currentStart < to) {
                                const intervalEndHour = currentStart.getHours() + 1;
                                const intervalEnd = new Date(currentStart);
                                intervalEnd.setHours(intervalEndHour, 0, 0, 0);
                                const currentEnd = new Date(Math.min(intervalEnd.getTime(), to.getTime()));

                                result.push({
                                    ...booking,
                                    from_datetime: currentStart,
                                    to_datetime: currentEnd
                                });
                                timeWiseData = [...timeWiseData, ...result];

                                currentStart = new Date(currentEnd);
                            }
                        });
                    }
                    item[item2] = []
                }
            })
            _.uniq(_.pluck(timeWiseData, "cabin_id"))?.forEach((id) => {
                const cabinsPluck = _.filter(timeWiseData, (data) => (data?.cabin_id === id && convertTo24HourFormat(dateConvert(data?.from_datetime, "time"), true) >= item?.cell_start && convertTo24HourFormat(dateConvert(data?.to_datetime, "time"), true) <= item?.cell_end) && dateConvert(item?.date, "iso-string")?.split("T")?.[0] === dateConvert(data?.from_datetime, "iso-string")?.split("T")?.[0]);
                cabinsPluck?.map((data) => {
                    const fromDate = new Date(data?.from_datetime);
                    const toDate = new Date(data?.to_datetime);
                    let fromTime = fromDate?.getMinutes();
                    let toTime = toDate?.getMinutes();
                    if (fromDate?.getHours() === toDate?.getHours()) {
                        data["minutes"] = (parseInt(fromTime) - parseInt(toTime)) === 0 ? 60 : (parseInt(fromTime) - parseInt(toTime));
                    } else {
                        data["minutes"] = parseInt(fromTime) - (parseInt(toTime) + 60);
                    }
                    data["top"] = (fromTime >= 30 || (data?.minutes === -45 && toTime === 0)) ? 50 : 0
                    data["left"] = (Math.abs(data?.minutes) === 15 && (toTime === 30 || toTime === 0)) ? 50 : 0
                    data["time"] = `${dateConvert(data?.from_datetime, "time")} - ${dateConvert(data?.to_datetime, "time")}`
                    data["booking_time"] = { start: convertTo24HourFormat(dateConvert(data?.from_datetime, "time"), true), end: convertTo24HourFormat(dateConvert(data?.to_datetime, "time"), true) }
                })
                item[`cabin_${id}`] = _.uniq(cabinsPluck, "time")?.sort((a, b) => new Date(a?.from_datetime) - new Date(b?.from_datetime));
            })
            return item;
        })
        setWeekRowData(formattedRowData);
    }

    const handleDateChange = (count) => {
        if (view === "day") {
            if (count === 0) {
                setDate(new Date());
            } else {
                const newDate = new Date(date);
                newDate.setDate(newDate.getDate() + count)
                setDate(newDate);
            }
        } else {
            if (count === 0) {
                setWeek({ start: (new Date()), end: (new Date()).setDate((new Date()).getDate() + 6) });
            } else {
                const start = new Date(week?.start);
                const end = new Date(week?.end);
                setWeek({ start: start.setDate(start.getDate() + (7 * count)), end: end.setDate(end.getDate() + (7 * count)) });
            }
        }
    }

    const handleCellClicked = (event) => {
        if (event?.column?.colId === "time" || event?.column?.colId === "week_days") {
            return;
        } else {
            if (new Date(event?.data?.date) < new Date()) {
                showInfo("Info", "You cannot book cabin for the selected date and time");
                setEditData({});
                return;
            } else {
                const dataStart = event?.data[event?.colDef?.field]?.[0]?.booking_time?.start;
                const dataEnd = event?.data[event?.colDef?.field]?.[event?.data[event?.colDef?.field]?.length - 1]?.booking_time?.end;
                if ((dataStart === event?.data?.cell_start && dataEnd === event?.data?.cell_end && editData?.book_by !== undefined && editData?.book_by !== loggedInUser?.user_code) || editData?.show_error) {
                    showInfo("Info", `${event?.colDef?.headerName} is already booked for this time slot`);
                    setEditData({});
                    return;
                } else {
                    if (view === "week") {
                        setShiftTime({ from: event?.data?.shift_start, to: event?.data?.shift_end });
                    }
                    const isFuture = timeStringToDate("00:00:00", event?.data?.date) > timeStringToDate("00:00:00", new Date());
                    let disableArray = [];
                    // set past time as disabled for request form

                    if (timeStringToDate(event?.data?.shift_start)?.getHours() < (new Date())?.getHours() && !isFuture) {
                        disableArray.push({ start: event?.data?.shift_start, end: convertTo24HourFormat(dateConvert(new Date(), "time"), true) });
                    }
                    if (isFuture) {
                        disableArray = disableArray?.concat(_.pluck(_.pluck(view === "week" ? _.filter(weekRowData, item => dateConvert(item?.date) === dateConvert(event?.data?.date)) : rowData, event?.column?.colId)?.flatMap(item => item), "booking_time"));
                    } else {
                        disableArray = disableArray?.concat(_.pluck(event?.data?.[event?.column?.colId], "booking_time"));
                    }
                    setFormSlot({
                        time: { cell_start: isFuture ? (event?.data?.shift_start || "09:00:00") : event?.data?.cell_start, cell_end: isFuture ? (event?.data?.shift_end || "22:00:00") : event?.data?.cell_end },
                        disable: disableArray,
                        is_future: isFuture
                    })
                    setBooking((prev) => ({ ...prev, columnData: { name: event?.colDef?.headerName, field: event?.column?.colId, cabin_id: parseInt(event?.column?.colId?.split("_")?.[1] || 0) }, data: event?.data }));
                    editData?.show_error !== undefined && delete editData?.show_error;
                    setShowBooking(true);
                }
            }
        }
    }

    return useMemo(() => ({
        date, handleDateChange, coldef, rowData, handleCellClicked, showBooking, setShowBooking, booking, setBooking, view, setView, weekColDef, weekRowData, week, shiftTime, getCabinBookingDetails, formSlot, loader, editData, setEditData
    }), [date, handleDateChange, coldef, rowData, handleCellClicked, showBooking, setShowBooking, booking, setBooking, view, setView, weekColDef, weekRowData, week, shiftTime, getCabinBookingDetails, formSlot, loader, editData, setEditData])
}